import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import '../styles/main.css';

const Checkout = () => {
  const { cartItems, clearCart } = useCart();
  const navigate = useNavigate();

  const totalAmount = cartItems.reduce((sum, item) => sum + item.price * item.qty, 0);

  const handlePayment = () => {
    const options = {
      key: "rzp_test_YourKeyHere", // Replace with your Razorpay key
      amount: totalAmount * 100, // Amount in paise
      currency: "INR",
      name: "Hungry King",
      description: "Order Payment",
      handler: function (response) {
        clearCart();
        navigate('/thankyou');
      },
      prefill: {
        name: "",
        email: "",
        contact: "",
      },
      theme: {
        color: "#ffd700",
      },
    };
    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  return (
    <div className="royal-background" style={{ padding: '2rem', minHeight: '100vh' }}>
      <h2 style={{ color: '#ffd700', textAlign: 'center', marginBottom: '2rem' }}>Checkout</h2>

      {cartItems.length === 0 ? (
        <p style={{ color: '#fff', textAlign: 'center' }}>Your cart is empty.</p>
      ) : (
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          {cartItems.map((item, idx) => (
            <div
              key={idx}
              style={{
                backgroundColor: '#001d4a',
                padding: '1rem',
                marginBottom: '1rem',
                borderRadius: '10px',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <div>
                <h3 style={{ marginBottom: '0.3rem', color: '#ffd700' }}>{item.name}</h3>
                <p style={{ margin: 0 }}>Qty: {item.qty}</p>
                <p style={{ margin: 0 }}>Price: ₹{item.price} × {item.qty} = ₹{item.price * item.qty}</p>
              </div>
              <img
                src={item.image}
                alt={item.name}
                style={{ width: '80px', height: '80px', objectFit: 'cover', borderRadius: '8px' }}
              />
            </div>
          ))}

          <h3 style={{ textAlign: 'right', color: '#ffd700' }}>Total: ₹{totalAmount}</h3>

          <div style={{ textAlign: 'center', marginTop: '2rem' }}>
            <button className="primary-btn large" onClick={handlePayment}>
              Pay Now
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Checkout;
